import React, { lazy, Suspense } from 'react';
import { Route, Switch, useHistory } from 'react-router-dom';

// Lazy load components
const AccountList = lazy(() => import('../Pages/AccountList'));
const AddAccount = lazy(() => import('../Pages/AddAccount'));

// Import loading overlay
import LoadingOverlay from 'react-loading-overlay';
import AccountView from "../Pages/AccountView";
import EditAccount from "../Pages/EditAccount";
LoadingOverlay.propTypes = undefined;

function AccountRoute() {
    const history = useHistory();

    return (
        <Switch>
            <Route
                exact
                path="/:lng/business/accounts"
                render={() => (
                    <Suspense fallback={<Loading />}>
                        <AccountList history={history} />
                    </Suspense>
                )}
            />
            <Route
                exact
                path="/:lng/business/accounts/list"
                render={() => (
                    <Suspense fallback={<Loading />}>
                        <AccountList history={history} />
                    </Suspense>
                )}
            />
            <Route
                exact
                path="/:lng/business/accounts/add"
                render={() => (
                    <Suspense fallback={<Loading />}>
                        <AddAccount history={history} />
                    </Suspense>
                )}
            />
            <Route
                exact
                path="/:lng/business/accounts/view/:slack"
                render={() => (
                    <Suspense fallback={<Loading />}>
                        <AccountView history={history} />
                    </Suspense>
                )}
            />
            <Route
                exact
                path="/:lng/business/accounts/edit/:slack"
                render={() => (
                    <Suspense fallback={<Loading />}>
                        <EditAccount history={history} />
                    </Suspense>
                )}
            />
        </Switch>
    );
};

export default AccountRoute;

function Loading() {
    return (
        <>
            <div className="wrapper">
                <span>Loading</span>
            </div>
        </>
    );
}
